export const CONFIRM = 'CONFIRM';